import { EDITORIAL_PLATFORMS } from "@/data/content";

export default function Marquee({ items = EDITORIAL_PLATFORMS }) {
  const loop = [...items, ...items];
  return (
    <div className="relative w-full max-w-[100vw] overflow-hidden border-y hairline py-6 bg-warm" data-testid="editorial-marquee">
      <div className="marquee-track">
        {loop.map((item, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="font-heading font-light text-2xl md:text-3xl text-navy/70 px-8 whitespace-nowrap">
              {item}
            </span>
            <span className="text-gold text-lg">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
